import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';
import { PayrollAuthority } from './payroll-authority';

export class PayrollDefinitionAuthority extends PayrollAuthority {

    public static readonly PAYROLL_DEFINITION_BASE = "definitions";

    constructor(authority: string) {
        super(combineAuth(PayrollDefinitionAuthority.PAYROLL_DEFINITION_BASE, authority));
    }

}
